<style>
    .select_color_outer {
        width: 39px;
        height: 39px;
        background: #fff;
        border: 1px solid #C4C4C4;
        border-radius: 35px;
        position: relative;
        margin-left: 10px;
        min-width: 39px;
        cursor: pointer;
    }
    .select_color_inner {
        width: 35px;
        height: 35px;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
        position: relative;
    }
    .select_color_inner:after {
        content: "";
        display: block;
        width: 0px;
        height: 0px;
        border: 6px solid transparent;
        border-top: 9px solid #404455;
        bottom: -5px;
        left: -9px;
        position: absolute;
    }
    .select_color_inner:before {
        content: "";
        display: block;
        width: 0px;
        height: 0px;
        border: 6px solid transparent;
        border-top: 9px solid #ffffff;
        bottom: -3px;
        left: -5px;
        position: absolute;
    }
    .select_color_menu_item {
        width: 39px;
        height: 39px;
        background: #fff;
        border: 1px solid #C4C4C4;
        border-radius: 35px;
        float: left;
        margin: 7px;
        cursor: pointer;
    }
    .gray_item {
        width: 35px;
        height: 35px;
        background: #F8F8F8;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
    }
    .gold_item {
        width: 35px;
        height: 35px;
        background: #EBD667;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
    }
    .green_item {
        width: 35px;
        height: 35px;
        background: #52B260;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
    }
    .black_item {
        width: 35px;
        height: 35px;
        background: #3C3C3C;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
    }
    .red_item {
        width: 35px;
        height: 35px;
        background: red;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
    }
    .blue_item {
        width: 35px;
        height: 35px;
        background: #433A8B;
        border-radius: 31px;
        margin: auto;
        margin-top: 2px;
    }
    #select_color_menu {
        max-width: 165px;
        background: #fff;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    }

:global(.tippy-tooltip.eda-theme) {
  background-color: #fff;
}
:global(.tippy-tooltip.eda-theme[data-placement^='top'] .tippy-arrow) {
  border-top-color: #fff;
  bottom: -3px;
}
:global(.tippy-tooltip.eda-theme[data-placement^='bottom'] .tippy-arrow) {
  border-bottom-color: #fff;
  top: -3px;
}
:global(.tippy-tooltip.eda-theme[data-placement^='left'] .tippy-arrow) {
  border-left-color: #fff;
}
:global(.tippy-tooltip.eda-theme[data-placement^='right'] .tippy-arrow) {
  border-right-color: #fff;
}
:global(.tippy-popper) {
  transform: translate3d(141px, 51px, 0px)!important;
}
</style>
<script>
    import 'tippy.js/themes/light.css';
    import 'tippy.js/dist/tippy.css';
    // import '../../public/uikit.css';
    import tippy from 'tippy.js';
    import { onMount } from 'svelte';
    import { mutations } from '../mainStore.js';
    export let track
    let colorList = []
    onMount(()=>{
        const template = document.getElementById('select_color_menu');
        tippy('.select_color_outer', {
            content: template,
            arrow: true,
            trigger: 'click',
            distance: 10,
            flip: true,
            duration: [null, null],
            interactive: true,
            theme: 'eda',
            hideOnClick: true,
            placement: 'bottom-start',
        });
        for (let i in track.color_list) {
            colorList.push({
                code: i,
                image: track.color_list[i]
            })
        }
        colorList = [...colorList]
        if (track.colorCode && track.full_image) {
            mutations.setColorTrack(track.colorCode, track.full_image)
        } else {
            changeColor(colorList[0])
        }
    })

    function changeColor(color){
       mutations.setColorTrack(color.code, color.image)
    }

    function findColorImage(colorName) {
        return ""
        // return $tabImagesArray.find((item)=>{return (item.type == track.name && item.name.indexOf(colorName)!= -1)})
    }
</script>
<div class="select_color_outer">
    <div class="select_color_inner" style="{'background-color: ' + track.colorCode}"></div>
</div>

<div class="hidden" style="display: none;">
    <div id="select_color_menu">
        {#each colorList as color}
            <div class="select_color_menu_item" on:click="{() => changeColor(color)}">
                <div class="gray_item" style="background-color: {color.code};"></div>
            </div>
        {/each}
        <div style="clear: both"></div>
    </div>
</div>
